module.exports = __webpack_public_path__ + "img/59.fb4fea41.jpg";